import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ToolOrderService extends Service {
	constructor(injector: Injector) {
		super("ToolOrder", injector);
	}

	complete(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Complete/${id}`, {});
	}

	forProductionTool(productionToolId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProductionTool/${productionToolId}`);
	}

	getAllGrid() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetAll`);
	}

	getAllIncomplete() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetAllIncomplete`);
	}

	getForBoard() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetForBoard`);
	}

	getFullDetails(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetFullDetails/${id}`);
	}

	updateStatus(id: number, status: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/UpdateStatus/${id}?status=${status}`, {});
	}

	updateToolStatus(productionToolId: number, status: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/UpdateToolStatus/${productionToolId}?status=${status}`, {});
	}
}
